export class ApiService {
  constructor(httpClient, apiUrl, requestTimeout, authStorageService, errorHandler) {
    this.httpClient = httpClient;
    this.apiUrl = apiUrl;
    this.requestTimeout = requestTimeout;
    this.authStorageService = authStorageService;
    this.errorHandler = errorHandler;
  }

  get(url, params) {
    return this.httpClient.get(this.getFullUrl(url), {
      params: params,
      timeout: this.requestTimeout,
      withCredentials: true,
      headers: this.getHeaders()
    }).then(this.onSuccess).catch(this.errorHandler.handle);
  }

  post(url, data) {
    return this.httpClient.post(this.getFullUrl(url), data, {
      withCredentials: true,
      timeout: this.requestTimeout,
      headers: this.getHeaders()
    }).then(this.onSuccess).catch(this.errorHandler.handle);
  }

  put(url, data) {
    return this.httpClient.put(this.getFullUrl(url), data, {
      withCredentials: true,
      timeout: this.requestTimeout,
      headers: this.getHeaders()
    }).then(this.onSuccess).catch(this.errorHandler.handle);
  }

  delete(url) {
    return this.httpClient.delete(this.getFullUrl(url), {
      withCredentials: true,
      timeout: this.requestTimeout,
      headers: this.getHeaders()
    }).then(this.onSuccess).catch(this.errorHandler.handle);
  }

  download(url, fileName) {
    return this.httpClient({
      url: this.getFullUrl(url),
      method: 'GET',
      responseType: 'blob',
      headers: this.getHeaders('GET')
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    });
  }

  getFullUrl(url) {
    return `${this.apiUrl}${url}`;
  }

  onSuccess(response) {
    return response.data;
  }

  getHeaders(method) {
    const headers = {};

    if (method === 'POST' || method === 'PUT') {
      headers['Content-Type'] = 'application/json';
    }

    if (this.authStorageService.isAuthenticated()) {
      const auth = this.authStorageService.getAuth();
      headers['Authorization'] = `${auth.token_type} ${auth.access_token}`;
    }
    
    return headers;
  }
}